// =============================================================================
// useTabBarClearance — exact bottom padding a scroller needs to clear the
// floating glass tab bar on THIS device (uses the live safe-area inset, so it is
// tighter than the flat worst-case `layout.bottomNavInset`). Keep this in lockstep
// with FloatingTabBar's geometry (host lift + bar body).
// =============================================================================
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { spacing } from '../../constants/theme';

// Intrinsic height of the bar body (glass padding + icon + label rows). Must match
// FloatingTabBar.barContent + item layout. Exported so screens can compose it.
export const FLOATING_TAB_BAR_BODY = 40;

/** Bottom padding (px) for content that scrolls underneath the floating tab bar. */
export function useTabBarClearance(extra = spacing.md): number {
  const insets = useSafeAreaInsets();
  // Mirror FloatingTabBar.host: paddingBottom = max(insets.bottom, md) + sm.
  const lift = Math.max(insets.bottom, spacing.md) + spacing.sm;
  return lift + FLOATING_TAB_BAR_BODY + extra;
}
